import React from "react";
import { clsx } from "clsx";

interface IMainProps extends React.PropsWithChildren {}

export default function Main({ children }: IMainProps) {
  return (
    <main className={clsx("flex", "flex-col", "items-center", "w-full")}>
      {children}
    </main>
  );
}
